import { render } from "./impersonate.vue?vue&type=template&id=274cabba"
import script from "./impersonate.vue?vue&type=script&lang=js"
export * from "./impersonate.vue?vue&type=script&lang=js"

import "./impersonate.vue?vue&type=style&index=0&id=274cabba&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__